export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#ff5a00] mb-3">Lakiasiat</p>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight mb-3">{title}</h1>
        {updated && <p className="font-mono text-xs text-white/40 mb-12">Päivitetty {updated}</p>}
        <div className="space-y-8 text-white/70 leading-relaxed [&_h2]:font-display [&_h2]:text-white [&_h2]:text-xl [&_h2]:tracking-tight [&_h2]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_a]:text-[#ff5a00] [&_.ph]:text-[#ff5a00] [&_.ph]:font-mono [&_.ph]:text-sm">
          {children}
        </div>
      </div>
    </div>
  );
}
